import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { StatusBarDefinition } from '../../types';

export interface StatusBarSection {
  cssClass: string;
  amount: number;
  width: number;
  tooltipText?: string;
  clickHandler: () => void;
}

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBarComponent {
  @HostBinding('attr.data-test-id')
  private readonly dataTestId = 'status-bar';

  @Input()
  set definition(definition: StatusBarDefinition[]) {
    this.statusBarSections = this.createStatusBarData(definition);
  }

  @Output()
  selectControlTicked = new EventEmitter<StatusBarDefinition>();

  statusBarSections: StatusBarSection[] = [];

  private createStatusBarData(definition: StatusBarDefinition[]): StatusBarSection[] {
    if (definition?.length) {
      const maxValue = definition.map((val) => val.count).reduce((prev, curr) => prev + curr, 0);
      const lastItem = definition[definition.length - 1];
      const countable = definition.slice(0, definition.length - 1).map(
        (def) =>
          ({
            cssClass: def.cssClass,
            amount: def.count,
            width: (def.count / maxValue) * 100 || 0, // In case maxValue is zero
            tooltipText: def.tooltipText,
            clickHandler: () => this.selectControlTicked.emit(def),
          } as StatusBarSection),
      );
      const lastPercent = 100 - countable.reduce((prev, curr) => prev + curr.width, 0);
      return [
        ...countable,
        {
          cssClass: lastItem.cssClass,
          amount: lastItem.count,
          width: lastPercent,
          tooltipText: lastItem.tooltipText,
          clickHandler: () => this.selectControlTicked.emit(lastItem),
        },
      ];
    } else {
      return [];
    }
  }
}
